import React from 'react';
import PhonicsLt from './phonics/PhonicsLt';
import { letterDataLt25 } from './phonics/phonics_data_lt25';

function PhonicsLt25() {
  return <PhonicsLt letterData={letterDataLt25} />;
}

export default PhonicsLt25;
